export const PRODUCTION_URL = 'https://dashboard.sllr.co/orders?token=';
export const BETA_URL_REDIRECT = 'https://dashboard.sllr.co/orders?token=';
export const BETA_URL_HOSTNAME = 'dashboard.sllr.co';
export const STAGING_URL_HOSTNAME = 'stg-dashboard.sllr.co';
export const DEV_URL_HOSTNAME = 'dev-dashboard.sllr.co';
export const PRODUCTION_URL_HOSTNAME = 'dashboard.sllr.co';
export const ERROR_CODES = {
  USER_NOT_FOUND: 1047,
  NOT_VALID: 1045,
  DELETED_ACCOUNT: 1101,
  PASSWORD_EXPIRED: 4133
};
export const CONSIGNEE_TRACKING_URL_MAPPER = (trackingNumber) => {
  const mapper = {
    [PRODUCTION_URL_HOSTNAME]: `https://bosta.co/tracking-shipments?shipment-number=${trackingNumber}`,
    [BETA_URL_HOSTNAME]: `https://bosta.co/tracking-shipments?shipment-number=${trackingNumber}`,
    [STAGING_URL_HOSTNAME]: `https://stg.bosta.co/tracking-shipments?shipment-number=${trackingNumber}`,
    localhost: `https://stg.bosta.co/tracking-shipments?shipment-number=${trackingNumber}`
  };

  return mapper[window.location.hostname] || mapper[PRODUCTION_URL_HOSTNAME];
};

export const PAYMENT_REDIRECT_URL = () => {
  const mapper = {
    [PRODUCTION_URL_HOSTNAME]: `https://dashboard.sllr.co/payment`,
    [STAGING_URL_HOSTNAME]: `https://stg-dashboard.sllr.co/payment`,
    [DEV_URL_HOSTNAME]: `https://dev-dashboard.sllr.co/payment`,
    localhost: `https://stg-dashboard.sllr.co/payment`
  };

  return mapper[window.location.hostname] || mapper[PRODUCTION_URL_HOSTNAME];
};

export const TWO_FACTOR_AUTH_ENABLED_STATUS_CODE = 206;

export const SECURITY_TYPES = {
  SMS: 'SMS_TWO_FA',
  APP: 'TOTP_TWO_FA',
  EMAIL: 'EMAIL_TWO_FA'
};
